export interface SuggestionCandidateSku {
  skuId: string;
  units: number;
  revenue: number;
  classification: unknown | null;
}

/** Only selling SKUs can block Product Setup. A newly imported SKU with no
 * classification must be suggested even when older product groups already
 * exist; never-sold catalog clutter can wait until its first sale. */
export function newlyUnclassifiedSellingSkuIds(
  skus: readonly SuggestionCandidateSku[],
): string[] {
  return skus
    .filter((sku) => sku.classification === null && (sku.units > 0 || sku.revenue > 0))
    .map((sku) => sku.skuId)
    .sort();
}
